import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MapFilterType {
  type: string;
  // 물건 종류
  multiItemStatus: string[];
  // 특수조건
  specialItemCondition: string[];
  // 특수조건 보기옵션
  specialItemCond: string;
  // 진행단계
  progressStatus: string[];
  // 가격
  minPrice: string;
  maxPrice: string;
  // 매각기일
  minSaleDate: string;
  maxSaleDate: string;
  // 유찰횟수
  minBidCount: string;
  maxBidCount: string;
}

interface MapContextProps {
  onRealDealList: boolean;
  setOnRealDealList: React.Dispatch<React.SetStateAction<boolean>>;
  iidx: number;
  setIidx: React.Dispatch<React.SetStateAction<number>>;
  modalOn: boolean;
  setModalOn: React.Dispatch<React.SetStateAction<boolean>>;
  makerType: string;
  setMarkerType: React.Dispatch<React.SetStateAction<string>>;
  makerCategory: string;
  setMarkerCategory: React.Dispatch<React.SetStateAction<string>>;
  topFilterType: string;
  setTopFilterType: React.Dispatch<React.SetStateAction<string>>;
  detailIdx: number;
  setDetailIdx: React.Dispatch<React.SetStateAction<number>>;
  detailModalOn: boolean;
  setDetailModalOn: React.Dispatch<React.SetStateAction<boolean>>;
  detailType: string;
  setDetailType: React.Dispatch<React.SetStateAction<string>>;
  mapFilter: MapFilterType;
  setMapFilter: React.Dispatch<React.SetStateAction<MapFilterType>>;
}

const MapContext = createContext<MapContextProps | undefined>(undefined);

export const MapProvider = ({ children }: { children: ReactNode }) => {
  const [onRealDealList, setOnRealDealList] = useState(false);
  const [iidx, setIidx] = useState(0);
  const [modalOn, setModalOn] = useState(false);
  const [makerType, setMarkerType] = useState('');
  const [makerCategory, setMarkerCategory] = useState('');
  const [topFilterType, setTopFilterType] = useState('');
  const [detailIdx, setDetailIdx] = useState(0);
  const [detailModalOn, setDetailModalOn] = useState(false);
  const [detailType, setDetailType] = useState('');
  const [mapFilter, setMapFilter] = useState<MapFilterType>({
    type: 'A,P,E',
    multiItemStatus: [],
    progressStatus: ['A', 'C'],
    specialItemCondition: [],
    specialItemCond: 'A',
    minPrice: '',
    maxPrice: '',
    minSaleDate: '',
    maxSaleDate: '',
    minBidCount: '',
    maxBidCount: '',
  });

  return (
    <MapContext.Provider
      value={{
        detailType,
        setDetailType,
        topFilterType,
        setTopFilterType,
        onRealDealList,
        setOnRealDealList,
        iidx,
        setIidx,
        modalOn,
        setModalOn,
        makerType,
        setMarkerType,
        makerCategory,
        setMarkerCategory,
        detailIdx,
        setDetailIdx,
        detailModalOn,
        setDetailModalOn,
        mapFilter,
        setMapFilter,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};

export const useMapContext = () => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMapContext must be used within a MapProvider');
  }
  return context;
};
